import { useEffect } from "react"
import types from "prop-types"
import { store } from "store"
import { setInitialSettings } from "reduxSlices/currentSettingsSlice"

const SetupGeneralSettingsInRedux = ({
  organizationId,
  organizationClockFormat,
  organizationColor,
  organizationShortName,
  organizationSubdomain,
  effectiveTimezone = undefined,
  taskNotifySettings = [],
  taskReminders = undefined,
  timezone = undefined,
}) => {
  useEffect(
    () => {
      const initialSettings = {
        organizationId,
        organizationClockFormat,
        organizationColor,
        organizationShortName,
        organizationSubdomain,
        timezone: timezone ?? undefined,
        effectiveTimezone: effectiveTimezone ?? undefined,
        taskReminders: taskReminders ?? undefined,
        taskNotifySettings: taskNotifySettings ?? [],
      }
      store.dispatch(setInitialSettings(initialSettings))
    },
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  return null
}

SetupGeneralSettingsInRedux.propTypes = {
  organizationId: types.number.isRequired,
  organizationClockFormat: types.string.isRequired,
  organizationColor: types.string.isRequired,
  organizationShortName: types.string.isRequired,
  organizationSubdomain: types.string.isRequired,
  timezone: types.string,
  effectiveTimezone: types.string,
  taskReminders: types.string,
  taskNotifySettings: types.arrayOf(types.shape({
    isEnabled: types.bool,
    settingType: types.string,
  })),
}

export default SetupGeneralSettingsInRedux
